/**
 * @generated SignedSource<<073a75def85eaf82d1f82664244bc5eb>>
 * @relayHash 3b781749868d4942c88d089a19528c90
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fae4e607aeeb5e52c1791fc097d912257273ac260563cc7b111658f5aef6fbcf

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fae4e607aeeb5e52c1791fc097d912257273ac260563cc7b111658f5aef6fbcf",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider
    }
  }
};

export default node;
